import {all, fork, put, takeEvery,takeLatest, call, delay} from "redux-saga/effects"

import * as actionTypes from "appRedux/actions/setup/roomInformation/BedTypeActionType"
import * as actionCreators from "appRedux/actions/setup/roomInformation/BedType"
import {userSignOut} from "appRedux/actions/Auth"

import { APIGetRequest,APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isUndefined,filter,orderBy } from "lodash" 
import { IndexedDBAdd,IndexDBGetDataAll } from "util/indexedDBLibrary"
import { isEmpty} from "lodash"
import { getItems } from "util/localStorage"
import { ApiResponse } from "constants/ActionTypes"

function* bedTypePreviewProcess(){
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/masterfile/bedType/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    
    try {
      const response:ApiResponse = yield APIGetRequest(url,API_PMS_HEADERS)
      if(response.status === 200)
      {     
            const bedTypeDataSource = orderBy(response.data,[o => o.name.toLowerCase()],['asc']).map((obj,key) =>{
              const container = {} as any
                    container.key = key
                    container.bed_type_id = obj.id
                    container.bed_type_name = obj.name
                    container.bed_type_code = obj.code
                    container.image_url = obj.image_url
                    container.enabled = obj.enabled
                return container
            })
            
            /* if no error put everything to reducer */
            yield put(actionCreators.bedTypeDataSourceUpdate(bedTypeDataSource))
            yield IndexedDBAdd("ListBoxDB","objStoreBedTypeList",bedTypeDataSource)
      }else{
            /* Show error message and signout */
            const {message,data} = response.data
            const processStatus = { status: false, action: "preview", message}
            yield put(actionCreators.bedTypeProcessSuccess(processStatus))
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
            
      }
      
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error}
        yield put(actionCreators.bedTypeProcessSuccess(processStatus))
    }
    
}

function* bedTypeSearchProcess({payload}:actionTypes.BedTypeSearch){

  const storeValue:any = IndexDBGetDataAll('ListBoxDB', 'objStoreBedTypeList')
  const ReformalData = [...storeValue[0]]
  const keyword = payload ? payload.toLowerCase() : undefined

  if(!isUndefined(keyword)){
      /* Search by name */
      const filtered = filter(ReformalData, function(o) {
        return o.bed_type_name.toLowerCase().indexOf(keyword) > -1
      })

      const mergeData = [...new Set([...filtered])]

      yield put(actionCreators.bedTypeDataSourceUpdate(mergeData))
  }else 
      yield put(actionCreators.bedTypeDataSourceUpdate(ReformalData))
}

function* bedTypeCreateProcess({payload}:actionTypes.BedTypeNew){
  const { bed_type_name,bed_type_code ,active:bedTypeActive , bedTypeIcon } = payload

  const bedTypeInfo = {} as any
        bedTypeInfo.name = bed_type_name
        bedTypeInfo.code = bed_type_code
        bedTypeInfo.enabled = bedTypeActive

      if (!isEmpty(bedTypeIcon)) {
          const dataSplit = bedTypeIcon.split(",");
          bedTypeInfo.image_type = dataSplit[0]
          bedTypeInfo.image = dataSplit[1]
      }

    
      try {
            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/masterfile/bedType/create/`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = bedTypeInfo
            const response:ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
                const processStatus = { status: true, action: "create", message:"Create success."}
                yield put(actionCreators.bedTypeProcessSuccess(processStatus))
                yield delay(100)
            }else{
              const {message,data} = response.data
              const processStatus = { status: false, action: "create", message}
              yield put(actionCreators.bedTypeProcessSuccess(processStatus))
              yield delay(100)
              yield put(actionCreators.bedTypeProcessReset())
              if(response.status === 403){
                /* if data is not null force signout */
                if(data)
                  yield put(userSignOut())
              } 
            }  

      } catch (error) {
            const processStatus = { status: false, action: "create", message:error}
            yield put(actionCreators.bedTypeProcessSuccess(processStatus))
            yield delay(100)
            yield put(actionCreators.bedTypeProcessReset())
      }
}

function* bedTypeUpdateProcess({payload}:actionTypes.BedTypeUpdate){
  const { bed_type_name,bed_type_code ,active:bedTypeActive , bedTypeIcon, bed_type_id } = payload

  const bedTypeInfo = {} as any
        bedTypeInfo.id = bed_type_id
        bedTypeInfo.name = bed_type_name
        bedTypeInfo.code = bed_type_code
        bedTypeInfo.enabled = bedTypeActive

      if (!isEmpty(bedTypeIcon)) {
          const dataSplit = bedTypeIcon.split(",");
          bedTypeInfo.image_type = dataSplit[0]
          bedTypeInfo.image = dataSplit[1]
      }else{
        bedTypeInfo.image = null
        bedTypeInfo.image_type = null
      }
  

  try {
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/bedType/update/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY  = bedTypeInfo
        const response:ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

        if(response.status === 200){
            const processStatus = { status: true, action: "update", message:"Update success."}
            yield put(actionCreators.bedTypeProcessSuccess(processStatus))
            yield delay(100)
        }else { 
          const {message,data} = response.data
          const processStatus = { status: false, action: "update", message}
          yield put(actionCreators.bedTypeProcessSuccess(processStatus))
          yield delay(100)
          yield put(actionCreators.bedTypeProcessReset())
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        } 

  } catch (error) {
        const processStatus = { status: false, action: "update", message:error}
        yield put(actionCreators.bedTypeProcessSuccess(processStatus))
        yield delay(100)
        yield put(actionCreators.bedTypeProcessReset())
  }
}

function* bedTypeRemoveProcess({payload}:actionTypes.BedTypeRemove){
    const bedTypeRemove = payload
  

    try{
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/bedType/delete/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY = {id : bedTypeRemove}
        const response:ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)
        if(response.status === 200){
          const processStatus = { status: true, action: "delete", message:"Delete success."}
          yield put(actionCreators.bedTypeProcessSuccess(processStatus))
          yield delay(100)
        }else{
          const {message,data} = response.data
          const processStatus = { status: false, action: "delete", message}
          yield put(actionCreators.bedTypeProcessSuccess(processStatus))
          yield delay(100)
          yield put(actionCreators.bedTypeProcessReset())
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }  
    }
    catch(error){
      const processStatus = { status: false, action: "delete", message:error}
      yield put(actionCreators.bedTypeProcessSuccess(processStatus))
      yield delay(100)
      yield put(actionCreators.bedTypeProcessReset())
    }
}

function* bedTypeSwitchProcess({payload}:actionTypes.BedTypeUpdate){
  const { id,name,code, enabled } = payload

  const bedTypeInfo = {} as any
        bedTypeInfo.id = id
        bedTypeInfo.name = name
        bedTypeInfo.code = code
        bedTypeInfo.enabled = enabled
  try {
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/bedType/update/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY  = bedTypeInfo
        const response:ApiResponse = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

        if(response.status === 200){
            const processStatus = { status: true, action: "bedTypeSwitch", message:"Update success."}
            yield put(actionCreators.bedTypeProcessSuccess(processStatus))
            yield delay(100)
            yield put(actionCreators.bedTypeProcessReset())
        }else { 
          const {message,data} = response.data
          const processStatus = { status: false, action: "bedTypeSwitch", message}
          yield put(actionCreators.bedTypeProcessSuccess(processStatus))
          yield delay(100)
          yield put(actionCreators.bedTypeProcessReset())
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        } 

  } catch (error) {
        const processStatus = { status: false, action: "bedTypeSwitch", message:error}
        yield put(actionCreators.bedTypeProcessSuccess(processStatus))
        yield delay(100)
        yield put(actionCreators.bedTypeProcessReset())
  }
}

/* Watcher Saga */
export function* bedTypePreview() {
  yield takeLatest(actionTypes.BED_TYPE_PREVIEW, bedTypePreviewProcess)
}
export function* bedTypeSearch(){
  yield takeLatest(actionTypes.BED_TYPE_SEARCH, bedTypeSearchProcess)
}
export function* bedTypeCreate(){
  yield takeEvery(actionTypes.BED_TYPE_NEW,bedTypeCreateProcess)
}
export function* bedTypeUpdate(){
  yield takeEvery(actionTypes.BED_TYPE_UPDATE, bedTypeUpdateProcess)
}
export function* bedTypeRemove(){
  yield takeEvery(actionTypes.BED_TYPE_REMOVE,bedTypeRemoveProcess)
}

export function* bedTypeSwitch(){
  yield takeEvery(actionTypes.BED_TYPE_SWITCH,bedTypeSwitchProcess)
}

export default function* rootSaga() {
  yield all([fork(bedTypePreview),
             fork(bedTypeCreate),
             fork(bedTypeUpdate),
             fork(bedTypeRemove),
            fork(bedTypeSwitch)
            ])


}
